import { getHtmlTagDefinition } from "@angular/compiler";
import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { getAllRouteGuards } from "@angular/router/src/utils/preactivation";
import { CookieService } from "ngx-cookie-service";
import { filter } from "rxjs/operators";

declare var gtag;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "Focus Têxtil";

  constructor(private _router: Router, private cookie: CookieService) {
    const navEndEvents$ = this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    
    if (window.location.href.indexOf("focustextil.com.br/site/") > -1) {
      navEndEvents$.subscribe((event: NavigationEnd) => {
        gtag("event", "page_view", {
          app_name: "focus-textil",
          screen_name: event.urlAfterRedirects,
        });
      });
    }
  }

  // modal
  showModal = true;

  closeBanner(value: string) {
    if (value === "exit") {
      this.showModal = false;
    }
  }

  setCookieVisit () {
    if (!this.cookie.get("firstVisit")) {
      this.cookie.set("visit", "0");
      this.cookie.set("firstVisit", "1", 30);
    }

    let visit = parseInt(this.cookie.get("visit")) + 1;

    this.cookie.set("visit", visit.toString());
    
    this.showModal = true;

  }

  ngOnInit() {
    this._router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.setCookieVisit();
  }
}
